<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">{{ payload.name }}</h4>
          <div>
            <b-button
              variant="info"
              :disabled="isValidating"
              @click="handleValidate"
              >Validate</b-button
            >
            <b-button variant="success" @click="handleExport">Export</b-button>
          </div>
        </div>
        <div class="card-body">
          <BForm @submit="handleSubmit">
            <h2>Jobboard</h2>
            <div class="row">
              <div class="col-md-4">
                <BFormGroup
                  label="Name"
                  :invalid-feedback="getFieldError('name')"
                  :state="!fieldHasError('name')"
                  aria-required="true"
                  v-b-popover.hover.right="
                    'The human readable name of the jobboard. (LeMarche.co) '
                  "
                >
                  <BFormInput v-model="payload.name" />
                </BFormGroup>
              </div>
              <div class="col-md-4">
                <BFormGroup
                  label="Domain"
                  :invalid-feedback="getFieldError('domain')"
                  :state="!fieldHasError('domain')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.domain" />
                </BFormGroup>
              </div>
              <div class="col-md-2">
                <BFormGroup
                  label="Country Code"
                  :invalid-feedback="getFieldError('country')"
                  :state="!fieldHasError('country')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.country" />
                </BFormGroup>
              </div>
              <div class="col-md-2">
                <BFormGroup
                  label="Region Code"
                  :invalid-feedback="getFieldError('region')"
                  :state="!fieldHasError('region')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.region" />
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="Categories"
                  :invalid-feedback="getFieldError('categories')"
                  :state="!fieldHasError('categories')"
                  aria-required="true"
                >
                  <Multiselect
                    v-model="payload.categories"
                    :options="categories"
                    :multiple="true"
                    label="label"
                    track-by="id"
                  ></Multiselect>
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="Specializations"
                  :invalid-feedback="getFieldError('specializations')"
                  :state="!fieldHasError('specializations')"
                  aria-required="true"
                >
                  <Multiselect
                    v-model="payload.specializations"
                    :options="specializations"
                    :multiple="true"
                    label="label"
                    track-by="id"
                  ></Multiselect>
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="Noc title concordance_id (accept comma separated input)"
                  :invalid-feedback="getFieldError('noc_titles')"
                  :state="!fieldHasError('noc_titles')"
                  aria-required="true"
                >
                  <Multiselect
                    v-model="payload.noc_titles"
                    :options="[]"
                    :multiple="true"
                    :taggable="true"
                    :closeOnSelect="false"
                    @tag="addComaSeparatedTag($event, payload.noc_titles)"
                  ></Multiselect>
                </BFormGroup>
              </div>
            </div>
            <h4>SEO</h4>
            <div class="row">
              <div class="col-md-6">
                <BFormGroup
                  label="SEO title name (en)"
                  :invalid-feedback="getFieldError('seo_title_en')"
                  :state="!fieldHasError('seo_title_en')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.seo_title_en" />
                </BFormGroup>
              </div>
              <div class="col-md-6">
                <BFormGroup
                  label="SEO title name (fr)"
                  :invalid-feedback="getFieldError('seo_title_fr')"
                  :state="!fieldHasError('seo_title_fr')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.seo_title_fr" />
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="SEO description (en)"
                  :invalid-feedback="getFieldError('seo_description_en')"
                  :state="!fieldHasError('seo_description_en')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.seo_description_en" />
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="SEO description (fr)"
                  :invalid-feedback="getFieldError('seo_description_fr')"
                  :state="!fieldHasError('seo_description_fr')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.seo_description_fr" />
                </BFormGroup>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="SEO keywords en (accept comma separated input)"
                  :invalid-feedback="getFieldError('seo_keywords_en')"
                  :state="!fieldHasError('seo_keywords_en')"
                  aria-required="true"
                >
                  <Multiselect
                    v-model="payload.seo_keywords_en"
                    :options="[]"
                    :multiple="true"
                    :taggable="true"
                    :closeOnSelect="false"
                    @tag="addComaSeparatedTag($event, payload.seo_keywords_en)"
                  ></Multiselect>
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="SEO keywords fr (accept comma separated input)"
                  :invalid-feedback="getFieldError('seo_keywords_fr')"
                  :state="!fieldHasError('seo_keywords_fr')"
                  aria-required="true"
                >
                  <Multiselect
                    v-model="payload.seo_keywords_fr"
                    :options="[]"
                    :multiple="true"
                    :taggable="true"
                    :closeOnSelect="false"
                    @tag="addComaSeparatedTag($event, payload.seo_keywords_fr)"
                  ></Multiselect>
                </BFormGroup>
              </div>
            </div>
            <h4>SEO Pages (pages emplois /jobs pages)</h4>
            <div class="row">
              <div class="col-md-6">
                <BFormGroup
                  label="Job Slug (en)"
                  :invalid-feedback="getFieldError('job_slug_en')"
                  :state="!fieldHasError('job_slug_en')"
                  aria-required="true"
                  v-b-popover.hover.right="
                    'The slug for the seo page url. E.g lemarche -> engineering'
                  "
                >
                  <BFormInput v-model="payload.job_slug_en" />
                </BFormGroup>
              </div>
              <div class="col-md-6">
                <BFormGroup
                  label="Job Slug (fr)"
                  :invalid-feedback="getFieldError('job_slug_fr')"
                  :state="!fieldHasError('job_slug_fr')"
                  aria-required="true"
                  v-b-popover.hover.right="
                    'The slug for the seo page url. E.g lemarche -> genie'
                  "
                >
                  <BFormInput v-model="payload.job_slug_fr" />
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <BFormGroup
                  label="Profession name (en)"
                  :invalid-feedback="getFieldError('profession_name_en')"
                  :state="!fieldHasError('profession_name_en')"
                  aria-required="true"
                  v-b-popover.hover.right="'E.g comptable'"
                >
                  <BFormInput v-model="payload.profession_name_en" />
                </BFormGroup>
              </div>
              <div class="col-md-6">
                <BFormGroup
                  label="Profession name (fr)"
                  :invalid-feedback="getFieldError('profession_name_fr')"
                  :state="!fieldHasError('profession_name_fr')"
                  aria-required="true"
                  v-b-popover.hover.right="'E.g comptable'"
                >
                  <BFormInput v-model="payload.profession_name_fr" />
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <BFormGroup
                  label="SEO page category name (en)"
                  :invalid-feedback="getFieldError('seo_category_en')"
                  :state="!fieldHasError('seo_category_en')"
                  aria-required="true"
                  v-b-popover.hover.right="'E.g comptabilité et en finance.'"
                >
                  <BFormInput v-model="payload.seo_category_en" />
                </BFormGroup>
              </div>
              <div class="col-md-6">
                <BFormGroup
                  label="SEO page category name (fr)"
                  :invalid-feedback="getFieldError('seo_category_fr')"
                  :state="!fieldHasError('seo_category_fr')"
                  aria-required="true"
                  v-b-popover.hover.right="'E.g comptabilité et en finance.'"
                >
                  <BFormInput v-model="payload.seo_category_fr" />
                </BFormGroup>
              </div>
            </div>
            <h4>Home page hero banner</h4>
            <div class="row">
              <div class="col-md-6">
                <BFormGroup
                  label="Jobboard Hero title (en)"
                  :invalid-feedback="getFieldError('hero_title_en')"
                  :state="!fieldHasError('hero_title_en')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.hero_title_en" />
                </BFormGroup>
              </div>
              <div class="col-md-6">
                <BFormGroup
                  label="Jobboard Hero title (fr)"
                  :invalid-feedback="getFieldError('hero_title_fr')"
                  :state="!fieldHasError('hero_title_fr')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.hero_title_fr" />
                </BFormGroup>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-12">
                <BFormGroup
                  label="Jobboard hero description (en)"
                  :invalid-feedback="getFieldError('jobboard_description_en')"
                  :state="!fieldHasError('jobboard_description_en')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.jobboard_description_en" />
                </BFormGroup>
              </div>
              <div class="col-md-12">
                <BFormGroup
                  label="Jobboard hero description (fr)"
                  :invalid-feedback="getFieldError('jobboard_description_fr')"
                  :state="!fieldHasError('jobboard_description_fr')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.jobboard_description_fr" />
                </BFormGroup>
              </div>
            </div>
            <h2>Product</h2>
            <div class="row">
              <div class="col-md-6">
                <BFormGroup
                  label="Product title (en)"
                  :invalid-feedback="getFieldError('product_title_en')"
                  :state="!fieldHasError('product_title_en')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.product_title_en" />
                </BFormGroup>
              </div>
              <div class="col-md-6">
                <BFormGroup
                  label="Product title (fr)"
                  :invalid-feedback="getFieldError('product_title_fr')"
                  :state="!fieldHasError('product_title_fr')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.product_title_fr" />
                </BFormGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BFormGroup
                  label="Product description (en)"
                  :invalid-feedback="getFieldError('product_description_en')"
                  :state="!fieldHasError('product_description_en')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.product_description_en" />
                </BFormGroup>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-12">
                <BFormGroup
                  label="Product description (fr)"
                  :invalid-feedback="getFieldError('product_description_fr')"
                  :state="!fieldHasError('product_description_fr')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.product_description_fr" />
                </BFormGroup>
              </div>
            </div>

            <div>
              <h2>Social Media</h2>
            </div>
            <div class="row mb-4">
              <div class="col-md-4">
                <BFormGroup
                  label="Facebook"
                  :invalid-feedback="getFieldError('facebook_url')"
                  :state="!fieldHasError('facebook_url')"
                  aria-required="true"
                  v-b-popover.hover.right="
                    'https://www.facebook.com/EmploisIngenierie'
                  "
                >
                  <BFormInput v-model="payload.facebook_url" />
                </BFormGroup>
              </div>
              <div class="col-md-4">
                <BFormGroup
                  label="Twitter"
                  :invalid-feedback="getFieldError('twitter_url')"
                  :state="!fieldHasError('twitter_url')"
                  aria-required="true"
                  v-b-popover.hover.right="
                    'https://www.facebook.com/EmploisIngenierie'
                  "
                >
                  <BFormInput v-model="payload.twitter_url" />
                </BFormGroup>
              </div>
              <div class="col-md-4">
                <BFormGroup
                  label="Linkedin"
                  :invalid-feedback="getFieldError('linkedin_url')"
                  :state="!fieldHasError('linkedin_url')"
                  aria-required="true"
                  v-b-popover.hover.right="
                    'https://www.facebook.com/EmploisIngenierie'
                  "
                >
                  <BFormInput v-model="payload.linkedin_url" />
                </BFormGroup>
              </div>
              <div class="col-md-4">
                <BFormGroup
                  label="Facebook app id"
                  :invalid-feedback="getFieldError('facebook_app_id')"
                  :state="!fieldHasError('facebook_app_id')"
                  aria-required="true"
                >
                  <BFormInput v-model="payload.facebook_app_id" />
                </BFormGroup>
              </div>
            </div>
            <div>
              <h2>Images</h2>
            </div>
            <div
              class="row"
              v-for="field in [
                { name: 'logo', format: 'png' },
                { name: 'logo_light', format: 'png' },
                { name: 'home_hero_image', format: 'jpg' },
                { name: 'favicon', format: 'ico' },
                { name: 'og_image', format: 'png' },
                { name: 'icon', format: 'svg' }
              ]"
              :key="field.name"
            >
              <div class="col-md-12">
                <b-form-group
                  :label="field.name"
                  :invalid-feedback="getFieldError(field.name)"
                  :state="!fieldHasError(field.name)"
                  aria-required="true"
                  label-cols-sm="2"
                  label-size="sm"
                >
                  <b-form-file
                    @change="handleImage($event, field.name)"
                    v-model="files[field.name]"
                    :state="Boolean(payload[field.name])"
                    :placeholder="`${field.name} (${field.format})`"
                    drop-placeholder="Drop file here..."
                  ></b-form-file>
                </b-form-group>
                <div v-if="payload[field.name]" class="image-preview mb-4">
                  <img :src="payload[field.name]" alt="" />
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <BFormGroup
                  label="Is specialized"
                  :invalid-feedback="getFieldError('is_specialized')"
                  :state="!fieldHasError('is_specialized')"
                  aria-required="true"
                >
                  <BFormRadio v-model="payload.is_specialized" :value="true"
                    >Yes</BFormRadio
                  >
                  <BFormRadio v-model="payload.is_specialized" :value="false"
                    >No</BFormRadio
                  >
                </BFormGroup>
              </div>
            </div>
            <BButton type="submit" variant="primary">Save</BButton>
          </BForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormRadio,
  BFormFile
} from "bootstrap-vue";
import Multiselect from "vue-multiselect";
import formValidation from "../mixins/formValidation";
export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    Multiselect,
    BFormRadio,
    BFormFile
  },
  mixins: [formValidation],
  props: {
    id: {
      required: true,
      type: [String, Number]
    }
  },
  async created() {
    await this.$http.get("/offer-attributes").then(({ data }) => {
      this.offerAttributes = data;
    });
    this.$http
      .get(`/enroll_admin/jobboard-spec/${this.id}`)
      .then(({ data }) => {
        Object.assign(this.payload, {
          ...data,
          noc_titles: data.noc_titles || [],
          seo_keywords_en: data.seo_keywords_en || [],
          seo_keywords_fr: data.seo_keywords_fr || [],
          categories:
            data.categories?.map(id =>
              this.categories.find(attribute => attribute.id === id)
            ) || [],
          specializations:
            data.specializations?.map(id =>
              this.specializations.find(attribute => attribute.id === id)
            ) || []
        });
      });
  },
  computed: {
    categories() {
      return this.offerAttributes.category?.map(this.attributeToOption) || [];
    },
    specializations() {
      return (
        this.offerAttributes.specialization?.map(this.attributeToOption) || []
      );
    }
  },
  data() {
    return {
      isValidating: false,
      offerAttributes: {},
      files: {
        logo: null,
        logo_light: null,
        home_hero_image: null,
        favicon: null,
        og_image: null
      },
      payload: {
        name: "",
        domain: "",
        country: "",
        region: "",
        facebook_url: "",
        twitter_url: "",
        linkedin_url: "",
        job_slug_en: "",
        job_slug_fr: "",
        profession_name_en: "",
        profession_name_fr: "",
        seo_title_en: "",
        seo_title_fr: "",
        seo_description_en: "",
        seo_description_fr: "",
        categories: [],
        specializations: [],
        noc_titles: [],
        seo_keywords_en: [],
        seo_keywords_fr: [],
        is_specialized: null,
        product_title_en: "",
        product_title_fr: "",
        product_description_en: "",
        product_description_fr: "",
        facebook_app_id: "",
        hero_title_en: "",
        hero_title_fr: "",
        jobboard_description_en: "",
        jobboard_description_fr: "",
        seo_category_en: "",
        seo_category_fr: "",
        logo: null,
        logo_light: null,
        home_hero_image: null,
        favicon: null,
        og_image: null,
        icon: null
      }
    };
  },
  methods: {
    handleImage(event, field) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.payload[field] = reader.result;
      };
      reader.readAsDataURL(file);
    },
    addComaSeparatedTag(tag, payload) {
      payload.push(...tag.split(","));
    },
    attributeToOption({ id, label }) {
      return {
        id,
        label: `${label.fr} | ${label.en}`
      };
    },
    handleExport() {
      this.$http
        .get(`/enroll_admin/jobboard-spec/${this.id}`)
        .then(({ data }) => {
          const url = window.URL.createObjectURL(
            new Blob([JSON.stringify(data, null, 2)])
          );
          const a = document.createElement("a");
          a.href = url;
          a.setAttribute(
            "download",
            `${data.name.replace(/[^\p{L}]/gu, "")}.json`
          );
          document.body.appendChild(a);
          a.click();
        });
    },
    handleValidate() {
      this.isValidating = true;
      this.$http
        .get(`/enroll_admin/jobboard-spec/${this.id}/validate`)
        .then(this.clearErrors)
        .catch(this.handleFormError)
        .finally(() => (this.isValidating = false));
    },
    handleSubmit(event) {
      event.preventDefault();

      this.$http
        .put(`/enroll_admin/jobboard-spec/${this.id}`, {
          ...this.payload,
          categories: this.payload.categories.map(({ id }) => id),
          specializations: this.payload.specializations.map(({ id }) => id)
        })
        .then(() =>
          this.$bvToast.toast("Changes have been saved", {
            title: "Success!",
            autoHideDelay: 3000,
            variant: "success"
          })
        )
        .catch(() =>
          this.$bvToast.toast("Something went wrong", {
            title: "Oups!",
            autoHideDelay: 3000,
            variant: "success"
          })
        );
    }
  }
};
</script>
